import Class from './v-tabs';
import './v-tabs@';

export default Class;